
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to check database connectivity status
 * @returns Object containing error state and loading state
 */
export const useDbConnectivity = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        // Simple query to test connection
        const { data, error } = await supabase.from('agents').select('id').limit(1);
        
        if (error) {
          console.error("Database connectivity issue:", error);
          setError("Unable to connect to the database. Please try again later.");
        } else {
          console.log("Database connection successful");
          setError(null);
        }
      } catch (err) {
        console.error("Error checking database connection:", err);
        setError("Network error. Please check your internet connection.");
      }
    };
    
    checkConnection();
  }, []);

  return { error };
};
